import React, { useState } from "react";
import "../CSS/Contact.css"; // Import your CSS file for styling

const coordinators = [
  { name: "BARANITHARAN", phone: "9363558391" },
  { name: "MANOJ KUMAR", phone: "7358644004" },
  { name: "MANODEEPAN", phone: "7904629859" },
  { name: "VIMALPRAKASH", phone: "9778230422" },
  { name: "SANJEEV", phone: "7708444149" },
  { name: "PRADHIP", phone: "6379808747" },
  { name: "NARMADHA", phone: "9360411522" },
];

const Contact = () => {
  const [selectedContact, setSelectedContact] = useState(null);

  const openPopup = (contact) => {
    setSelectedContact(contact);
  };

  const closePopup = () => {
    setSelectedContact(null);
  };

  return (
    <div className="contact-container" id="contact">
      <h2 className="contact-title">Contact Our Student Co-Ordinators</h2>
      <div className="contact-grid">
        {coordinators.map((coordinator, index) => (
          <div className="contact-card" key={index}>
            <h3>{coordinator.name}</h3>
            <button onClick={() => openPopup(coordinator)}>
              {coordinator.phone}
            </button>
          </div>
        ))}
      </div>

      {selectedContact && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closePopup}>
              &times;
            </span>
            <h3>{selectedContact.name}</h3>
            <p>Phone: {selectedContact.phone}</p>
            <div className="popup-buttons">
              <a
                href={`tel:${selectedContact.phone}`}
                className="popup-button call"
              >
                📞 Call
              </a>
              <a
                href={`https://wa.me/91${selectedContact.phone}`}
                target="_blank"
                rel="noopener noreferrer"
                className="popup-button whatsapp"
              >
                💬 WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;


